// import MissionTransformHelper from "@/Helpers/800/mission.transform";
import Vue from 'vue';
class UserDetail {
  constructor(id, firstName, lastName, yearOfAge, gender, nationality, note, isUnknown, monthOfAge,
    ageTotalDays, nationalCode, clothesColorAndType, specialCharacteristic, birthDate, patientResult, hospitalId) {
    this.id = id
    this.isUnknown = isUnknown;
    this.firstName = firstName;
    this.lastName = lastName;
    this.yearOfAge = yearOfAge;
    this.monthOfAge = monthOfAge;
    this.ageTotalDays = ageTotalDays;
    this.nationalCode = nationalCode;
    this.birthDate = birthDate;
    this.gender = gender;
    this.nationality = nationality;
    this.clothesColorAndType = clothesColorAndType;
    this.specialCharacteristic = specialCharacteristic;
    this.note = note;
    this.patientResult = patientResult;
    this.hospitalId = hospitalId;
  }
}
export default {
  inject: ['load'],
  // mixins: [MissionTransformHelper],
  data() {
    return {
      imgAttach: null,
      imgAttach_inList: null,
      triageAnswerFor115: null,
      allAttachment: [],
      listEditPationts: [],
      missionConfirmations: [],
      disabelConfirm: false,
      isChildren: false,
      userDetail: new UserDetail(null, '', '', null, '', '', '', false, null, null, null, '', '', '', null, null),

    };
  },
  methods: {
    setMissionTriageAnswer: function (
      answerId,
      genralStatus,
      chiefComplaintStatus,
      answerColor,
      answerHint,
      questionId,
      answerRank,
      qCheifComlpaint,
    ) {
      /* if (genralStatus == true && chiefComplaintStatus == true) {
                 this.snackText = "برای ادامه روند تریاژ به بخش تریاژ تلفنی مراجعه کنید";
                 this.$refs.snackRef.snackModel = true;
                 this.snackColor = "#FF5252";
                 this.snakIcon = "mdi-information";
                 return;
             }*/
      this.missionRank = Number(answerRank);
      /*for (let i = 0; i < this.genaralTriageMap.length; i++) {
                if (this.genaralTriageMap[i].questionId == questionId) {
                    let deleteCount = (this.genaralTriageMap.length - 1) - i;
                    if (deleteCount > 0) {
                        this.genaralTriageMap.splice(i + 1, deleteCount)
                    }
                }
            }*/
      if (answerRank == 0) {
        this.headerBackgroundClass = 'header-back-0';
      } else if (answerRank == 1) {
        this.headerBackgroundClass = 'header-back-1';
      } else if (answerRank == 2) {
        this.headerBackgroundClass = 'header-back-2';
      } else if (answerRank == 3) {
        this.headerBackgroundClass = 'header-back-3';
        this.showTostAlarm();
      } else {
        this.headerBackgroundClass = 'header-back';
      }
      this.genaralTriageMap[this.genaralTriageMap.length - 1].answerColor = answerColor;
      /* if (genralStatus == true) {
                 for (let i = 0; i < this.genaralTriageMap.length; i++) {
                     if (this.genaralTriageMap[i].questionId == questionId) {
                         let deleteCount = (this.genaralTriageMap.length - 1) - i;
                         if (deleteCount > 0) {
                             this.genaralTriageMap.splice(i + 1, deleteCount)
                         }
                     }
                 }
                 this.genaralTriageMap[this.genaralTriageMap.length - 1].answerColor = answerColor;
             } else {
                 for (let i = 0; i < this.triageMap.length; i++) {
                     if (this.triageMap[i].questionId == questionId) {
                         let deleteCount = (this.triageMap.length - 1) - i;
                         if (deleteCount > 0) {
                             this.triageMap.splice(i + 1, deleteCount)
                         }
                     }
                 }
                 this.triageMap[this.triageMap.length - 1].answerColor = answerColor;
             }*/
      let data = {
        uniqueId: this.uniqueId,
        triageAnswerId: Number(answerId),
      };
      /*if (!this.load.val) {
                this.load.val = true;
            }*/
      this.$store.dispatch('missionTriageAnswer115', data).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          let temp = this.$store.state.missionModule.missionTriageAnswerFor115;
          if (temp) {
            if (this.formLoad) {
              let hasChiefComlaint = false;
              if (temp.chiefComplaint) {
                hasChiefComlaint = true;
                //this.selectedNurseDesition = temp.chiefComplaint;
                /*if (genralStatus == true) {
                                    this.snackText = "تشخیص: " + this.selectedNurseDesition.title + "- " + "به تریاژتلفنی مراجعه کنید."
                                    this.$refs.snackRef.snackModel = true;
                                    this.snackColor = "#0A6ADA";
                                    this.snakIcon = "mdi-information";
                                }*/
              }
              if (answerHint != '' && answerHint != '-') {
                this.showTostMessage(answerHint);
              }
              this.lastGeneralTriageHint = answerHint;
              let cheifComplaintChage = false;
              if (temp.chiefComplaint) {
                if (qCheifComlpaint != temp.chiefComplaint.title) {
                  cheifComplaintChage = true;
                }
              }
              this.genaralTriageMap.push({
                questionId: temp.id,
                questionTag: temp.tag ? temp.tag : '-',
                answerColor: '#F4F4F4',
                fullTriageItem: {},
                cheifComplaintChage: cheifComplaintChage,
                cheifComplaintChageText: temp.chiefComplaint ? temp.chiefComplaint.title : null,
              });
              this.genaralTriage = {
                questionId: temp.id,
                questionTitle: temp.title,
                hasChiefComlaint: hasChiefComlaint,
                isGeneral: temp.isGeneral,
                answers: [],
              };
              if (temp.triageAnswers) {
                for (let i = 0; i < temp.triageAnswers.length; i++) {
                  let color = '#F4F4F4';
                  if (
                    temp.triageAnswers[i].rank !== null ||
                    temp.triageAnswers[i].rank !== undefined
                  ) {
                    color = this.checkRankForColor(temp.triageAnswers[i].rank);
                  }
                  this.genaralTriage.answers.push({
                    answerId: temp.triageAnswers[i].id,
                    answerTitle: temp.triageAnswers[i].title,
                    answerHint: temp.triageAnswers[i].hint ? temp.triageAnswers[i].hint : '-',
                    answerRank: temp.triageAnswers[i].rank ? temp.triageAnswers[i].rank : null,
                    color: color,
                    hint: temp.triageAnswers[i].hint ? temp.triageAnswers[i].hint : '-',
                    questionCheifComlpaint: temp.chiefComplaint ? temp.chiefComplaint.title : null,
                  });
                }
              }
              this.genaralTriageMap[this.genaralTriageMap.length - 1].fullTriageItem =
                this.genaralTriage;
              this.generalTriageCounter++;
              /*if (temp.isGeneral == true) {
                                if (answerHint != "" && answerHint != "-") {
                                    this.showTostMessage(answerHint);
                                }
                                this.lastGeneralTriageHint = answerHint;
                                this.genaralTriageMap.push({ questionId: temp.id, questionTag: (temp.tag) ? temp.tag : "-", answerColor: "#212121", fullTriageItem: {} });
                                this.genaralTriage = {
                                    questionId: temp.id,
                                    questionTitle: temp.title,
                                    hasChiefComlaint: hasChiefComlaint,
                                    isGeneral: temp.isGeneral,
                                    answers: [],
                                }
                                if (temp.triageAnswers) {
                                    for (let i = 0; i < temp.triageAnswers.length; i++) {
                                        let color = "#212121";
                                        if (temp.triageAnswers[i].rank !== null || temp.triageAnswers[i].rank !== undefined) {
                                            color = this.checkRankForColor(temp.triageAnswers[i].rank);
                                        }
                                        this.genaralTriage.answers.push({ answerId: temp.triageAnswers[i].id, answerTitle: temp.triageAnswers[i].title, answerHint: temp.triageAnswers[i].hint ? temp.triageAnswers[i].hint : "-", answerRank: temp.triageAnswers[i].rank ? temp.triageAnswers[i].rank : null, color: color, hint: temp.triageAnswers[i].hint ? temp.triageAnswers[i].hint : "-" })
                                    }
                                }
                                this.genaralTriageMap[this.genaralTriageMap.length - 1].fullTriageItem = this.genaralTriage;
                                this.generalTriageCounter++;
                            } else {
                                if (answerHint != "" && answerHint != "-") {
                                    this.showTostMessage(answerHint);
                                }
                                this.lastTriageHint = answerHint;
                                this.triageMap.push({ questionId: temp.id, questionTag: (temp.tag) ? temp.tag : "-", answerColor: "#212121", fullTriageItem: {} });
                                this.triage = {
                                    questionId: temp.id,
                                    questionTitle: temp.title,
                                    hasChiefComlaint: hasChiefComlaint,
                                    isGeneral: temp.isGeneral,
                                    answers: [],
                                }
                                if (temp.triageAnswers) {
                                    for (let i = 0; i < temp.triageAnswers.length; i++) {
                                        let color = "#212121";
                                        if (temp.triageAnswers[i].rank !== null || temp.triageAnswers[i].rank !== undefined) {
                                            color = this.checkRankForColor(temp.triageAnswers[i].rank);
                                        }
                                        this.triage.answers.push({ answerId: temp.triageAnswers[i].id, answerTitle: temp.triageAnswers[i].title, answerHint: temp.triageAnswers[i].hint ? temp.triageAnswers[i].hint : "-", answerRank: temp.triageAnswers[i].rank ? temp.triageAnswers[i].rank : null, color: color, hint: temp.triageAnswers[i].hint ? temp.triageAnswers[i].hint : "-" })
                                    }
                                }
                                this.triageMap[this.triageMap.length - 1].fullTriageItem = this.triage;
                                this.triageCounter++;
                            }*/
            }
          } else {
            this.lastGeneralTriageHint = answerHint;
            this.showTostMessage(answerHint);
            /*if (genralStatus) {
                            if (answerHint) {
                                this.lastGeneralTriageHint = answerHint;
                                this.showTostMessage(answerHint);
                            }
                        } else {
                            if (answerHint) {
                                this.lastTriageHint = answerHint;
                                this.showTostMessage(answerHint);
                            }
                        }*/
            /*this.snackText = "پایان الگوریتم تریاژ";
                        this.$refs.snackRef.snackModel = true;
                        this.snackColor = "#0A6ADA";
                        this.snakIcon = "mdi-information";*/
          }
        } else {
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setMissionTriageAnswer(
                  answerId,
                  genralStatus,
                  chiefComplaintStatus,
                  answerColor,
                  answerHint,
                  questionId,
                  answerRank,
                  qCheifComlpaint,
                );
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setMissionTriageAnswer(
                  answerId,
                  genralStatus,
                  chiefComplaintStatus,
                  answerColor,
                  answerHint,
                  questionId,
                  answerRank,
                  qCheifComlpaint,
                );
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    setClinicalTriageFor115MisssionFunction: function (clinicalTriageId) {
      let data = {
        uniqueId: this.uniqueId,
        clinicalTriageId: Number(clinicalTriageId),
      };
      this.$store.dispatch('setClinicalTriageFor115Misssion', data).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          let temp = [];
          temp = this.compliantClinicalTriageList;
          this.compliantClinicalTriageList = [];
          for (let i = 0; i < temp.length; i++) {
            if (temp[i].id == clinicalTriageId) {
              temp[i].isDisable = true;
              temp[i].isSelected = true;
              let flag = false;
              for (let j = 0; j < this.selectedCompliantClinicalTriageList.length; j++) {
                if (this.selectedCompliantClinicalTriageList[j] == clinicalTriageId) {
                  flag = true;
                }
              }
              if (flag == false) {
                this.selectedCompliantClinicalTriageList.push(temp[i]);
              }
            }
          }
          this.compliantClinicalTriageList = temp;
        } else {
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setClinicalTriageFor115Misssion(clinicalTriageId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setClinicalTriageFor115Misssion(clinicalTriageId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllCurrentMissionForFormFunction: function () {
      this.$store.dispatch('getAllCurrentAddressForForm').then(() => {
        if (this.$store.state.missionModule.successFlag) {
          // if (this.$store.state.missionModule.allCurrentAddressForForm && this.$store.state.missionModule.allCurrentAddressForForm?.length > 0) {
          //   this.onlineMissionList = this.$store.state.missionModule.allCurrentAddressForForm ?? [];
          // } else {
          //   this.onlineMissionList = [];
          // }
          const addresses = this.$store.state.missionModule?.allCurrentAddressForForm;
          this.onlineMissionList = (Array.isArray(addresses) && addresses.length > 0) ? addresses : [];
        } else {
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllCurrentMissionForFormFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllCurrentMissionForFormFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfAttachmentMissionFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllAttachmentMission').then(() => {
        if (this.$store.state.missionModule.successFlag) {
          this.allAttachment = [];
          this.allAttachment = this.$store.state.missionModule.allAttachment?.filter(i => i?.isClickable == true);
          this.allAttachment.forEach((c) => (c.check = false));
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfAttachmentMissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfAttachmentMissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    sendMissionToDispatchFuncion: function () {
      let latitude = null;
      let longitude = null;
      if (this.position) {
        latitude = this.position.lat;
        longitude = this.position.lng;
      }
      let gender = null;
      if (this.patientGender != null && this.patientGender != undefined) {
        gender = Number(this.patientGender);
      }
      let missionInformTypeId = null;
      if (this.missionInformTypeId != null && this.missionInformTypeId != undefined) {
        missionInformTypeId = Number(this.missionInformTypeId);
      }

      let data = {
        rank: Number(this.missionRank),
        callerId: this.callerId,
        otherPhoneNumber: this.compliantRecoveryPhone,
        hasDoctorConsultant: this.compliantHasDoctorConsultant,
        postalCode: this.compliantPostalCode,
        chiefComplaintNote: this.complaintNote,
        missionCreationType: this.missionCreationType,
        latitude: latitude,
        longitude: longitude,
        isLocationConfirmed: this.acceptLocation,
        voiceUniqueId: this.uniqueId,
        note: this.compliantMoreInformationNote,
        extension: this.destination,
        informTypeId: missionInformTypeId,
        numberOfPatients: this.numberOfPatients,
        chiefComplaintText: this.selectedChiefComplaint ? this.selectedChiefComplaint : null,
        diagnosisId: this.selectedNurseDesition ? Number(this.selectedNurseDesition.id) : null,
        address: this.complaintAddress,
        cityId: this.selectedCity ? this.selectedCity.id : null,
        sendLocationSMS: this.sendLocationSMS,
        mission115Suggestions: [],
        missionCreationDetail: {
          firstName: this.patientFirstName,
          lastName: this.patientLastName,
          gender: gender,
          relation: this.patientRelation,
          ageMonth: this.patientAgeMonth ? Number(this.patientAgeMonth) : null,
          ageYear: this.patientAgeYear ? Number(this.patientAgeYear) : null,
          ageDay: this.patientAgeDay ? Number(this.patientAgeDay) : null,
          isNewBorn: this.isPatientNewBorn,
          nationalCode: this.patientNationalCode ? this.patientNationalCode : null,
        },
        missionTags: [],
        otherOrganizations: [],
      };
      for (let i = 0; i < this.compliantTag.length; i++) {
        data.missionTags.push({ tagId: Number(this.compliantTag[i]) });
      }
      for (let i = 0; i < this.compliantOtherOrganizations.length; i++) {
        data.otherOrganizations.push(Number(this.compliantOtherOrganizations[i]));
      }
      for (let i = 0; i < this.listOfSelectedCodes.length; i++) {
        data.mission115Suggestions.push({
          count: Number(this.listOfSelectedCodes[i].count),
          vehicleTypeId: Number(this.listOfSelectedCodes[i].id),
        });
      }
      if (data.missionTags.length == 0) {
        data.missionTags = null;
      }
      if (data.mission115Suggestions.length == 0) {
        data.mission115Suggestions = null;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('sendMissionToDispatch', data).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = 'ماموریت با موفقیت برای کارشناس 800 ارسال شد.';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.missionId = this.$store.state.missionModule.sentMission.id;
          this.isFinalize = true;
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.sendMissionToDispatchFuncion();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.sendMissionToDispatchFuncion();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    endCallFunction: function (callBackType, callTagId, missionId, uniqueId_NewCall = '') {

      const refKey = `newCallComponent_${uniqueId_NewCall}`;
      const newCallInstanceRef = this.$root.$refs[refKey];
      if (!newCallInstanceRef) {
        return
      }

      let mainData = null;

      const setData = () => {
        if (callBackType == 'main') {
          if (callTagId === 2) {
            if (!this.selectedChiefComplaint) {
              this.showErrorAlert('شکایت اصلی نمی تواند خالی باشد.');
              return false;
            }
            if (this.type == 'call') {
              if (!this.callerId) {
                this.showErrorAlert('تلفن اصلی نمی تواند خالی باشد');
                return false;
              }
            } else if (this.type == 'hand') {
              if (!this.compliantRecoveryPhone) {
                this.showErrorAlert('تلفن پیگیری نمی تواند خالی باشد');
                return false;
              }
            }
          }
        }

        if (callTagId) {
          newCallInstanceRef.callTagId = callTagId;
        }
        if (missionId) {
          newCallInstanceRef.mainMissionId = missionId;
        }
        let latitude = null;
        let longitude = null;
        if (newCallInstanceRef.position) {
          latitude = this.position.lat;
          longitude = this.position.lng;
        }
        let gender = null;
        if (
          newCallInstanceRef.patientGender != null &&
          newCallInstanceRef.patientGender != undefined
        ) {
          gender = Number(this.patientGender);
        }
        let missionInformTypeId = null;
        if (
          newCallInstanceRef.missionInformTypeId != null &&
          newCallInstanceRef.missionInformTypeId != undefined
        ) {
          missionInformTypeId = Number(newCallInstanceRef.missionInformTypeId);
        }

        let calculatedDuration = null;
        if (this.showPassedTime) {
          let tempDuration = this.showPassedTime;
          let duration = tempDuration.split(':');
          calculatedDuration = Number(duration[0] * 60) + Number(duration[1]);
        }

        let data = {
          callerId: this.callerId,
          otherPhoneNumber:
            newCallInstanceRef.compliantRecoveryPhone || this.compliantRecoveryPhone,
          hasDoctorConsultant: newCallInstanceRef.compliantHasDoctorConsultant,
          postalCode: newCallInstanceRef.compliantPostalCode,
          chiefComplaintNote: newCallInstanceRef.complaintNote || this.complaintNote,
          missionCreationType:
            newCallInstanceRef.missionCreationType || this.missionCreationType,
          latitude: latitude,
          longitude: longitude,
          isLocationConfirmed: newCallInstanceRef.acceptLocation,
          voiceUniqueId: this.uniqueId,
          extension: newCallInstanceRef.destination,
          informTypeId: missionInformTypeId || Number(this.missionInformTypeId),
          chiefComplaintText:
            newCallInstanceRef.selectedChiefComplaint || this.selectedChiefComplaint,
          diagnosisId:
            newCallInstanceRef.selectedNurseDesition?.id || this.selectedNurseDesition?.id,
          address: newCallInstanceRef.complaintAddress || this.complaintAddress,
          callTagId: newCallInstanceRef.callTagId || this.callTagId,
          note:
            newCallInstanceRef.compliantMoreInformationNote ||
            this.compliantMoreInformationNote,
          cityId: newCallInstanceRef.selectedCity?.id || this.selectedCity?.id,
          mainMissionId: missionId,
          duration: calculatedDuration,
          missionCreationDetail: {
            firstName: newCallInstanceRef.patientFirstName || this.patientFirstName,
            lastName: newCallInstanceRef.patientLastName || this.patientLastName,
            gender: gender,
            relation: newCallInstanceRef.patientRelation || this.patientRelation,
            ageMonth: newCallInstanceRef.patientAgeMonth || this.patientAgeMonth || null,
            ageYear: newCallInstanceRef.patientAgeYear || this.patientAgeYear || null,
            ageDay: this.patientAgeDay ? Number(this.patientAgeDay) : null,
            isNewBorn: this.isPatientNewBorn,
            nationalCode: newCallInstanceRef.patientNationalCode || this.patientNationalCode,
          },
          missionTags: [],
        };
        if (this.selectedEndCallId === 2) data.rank = this.missionRank;
        for (let i = 0; i < newCallInstanceRef.compliantTag.length; i++) {
          data.missionTags.push({
            tagId: Number(newCallInstanceRef.compliantTag[i]) || Number(this.compliantTag[i]),
          });
        }
        if (data.missionTags.length == 0) {
          data.missionTags = null;
        }
        return data;
      };
      mainData = setData();
      if (setData()) {
        this.load.val = true;
        this.$store.dispatch('endCall', mainData).then(() => {
          if (this.$store.state.missionModule.successFlag) {
            if (callBackType == "main") {
              this.cleanForm();
              this.$root.$refs.Home.closeForm(uniqueId_NewCall);
              if (this.type == "hand") {
                this.getListOfCurrentMissionFunction();
              }
            } else if (callBackType == "edit") {
              newCallInstanceRef.currentMissionModal = false;
              newCallInstanceRef.cleanForm();
              this.$root.$refs.Home.closeForm(uniqueId_NewCall);

              if (newCallInstanceRef.type == "hand") {
                newCallInstanceRef.getListOfCurrentMissionFunction();
              }
            }
            if (this.load.val) {
              this.load.val = false;
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.missionModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.endCallFunction(callBackType, callTagId, missionId, uniqueId_NewCall);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.endCallFunction(callBackType, callTagId, missionId, uniqueId_NewCall);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
      } else return;
    },
    finalizeMissionFuncion: function (questionIdsList, answerIdsList) {
      if (this.missionRank == null || this.missionRank == undefined) {
        this.snackText = 'اولویت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.selectedChiefComplaint) {
        this.snackText = 'شکایت اصلی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.selectedNurseDesition) {
        this.snackText = 'تشخیص احتمالی پرستار نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.complaintAddress) {
        this.snackText = 'آدرس نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.selectedCity) {
        if (!this.selectedCity.id) {
          this.snackText = 'شهر نمی تواند خالی باشد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else {
        this.snackText = 'شهر نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.type == 'call') {
        if (!this.callerId) {
          this.snackText = 'تلفن اصلی نمی تواند خالی باشد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else if (this.type == 'hand') {
        if (!this.compliantRecoveryPhone) {
          this.snackText = 'تلفن پیگیری نمی تواند خالی باشد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      }
      let latitude = null;
      let longitude = null;
      if (this.position) {
        latitude = this.position.lat;
        longitude = this.position.lng;
      }
      let gender = null;
      if (this.patientGender != null && this.patientGender != undefined) {
        gender = Number(this.patientGender);
      }
      let missionInformTypeId = null;
      if (this.missionInformTypeId != null && this.missionInformTypeId != undefined) {
        missionInformTypeId = Number(this.missionInformTypeId);
      }
      let tempDuration = this.showPassedTime;
      let duration = tempDuration.split(':');
      let calculatedDuration = Number(duration[0] * 60) + Number(duration[1]);
      let data = {
        id: Number(this.missionId),
        rank: Number(this.missionRank),
        callerId: this.callerId,
        otherPhoneNumber: this.compliantRecoveryPhone,
        hasDoctorConsultant: this.compliantHasDoctorConsultant,
        postalCode: this.compliantPostalCode,
        chiefComplaintNote: this.complaintNote,
        missionCreationType: this.missionCreationType,
        latitude: latitude,
        longitude: longitude,
        isLocationConfirmed: this.acceptLocation,
        voiceUniqueId: this.uniqueId,
        extension: this.destination,
        informTypeId: missionInformTypeId,
        chiefComplaintText: this.selectedChiefComplaint ? this.selectedChiefComplaint : null,
        diagnosisId: this.selectedNurseDesition ? Number(this.selectedNurseDesition.id) : null,
        address: this.complaintAddress,
        cityId: this.selectedCity ? this.selectedCity.id : null,
        mission115Suggestions: [],
        note: this.compliantMoreInformationNote,
        duration: calculatedDuration,
        missionCreationDetail: {
          firstName: this.patientFirstName,
          lastName: this.patientLastName,
          gender: gender,
          relation: this.patientRelation,
          ageMonth: this.patientAgeMonth ? Number(this.patientAgeMonth) : null,
          ageDay: this.patientAgeDay ? Number(this.patientAgeDay) : null,
          isNewBorn: this.isPatientNewBorn,
          ageYear: this.patientAgeYear ? Number(this.patientAgeYear) : null,

          nationalCode: this.patientNationalCode ? this.patientNationalCode : null,
        },
        missionTriageAnswers: [...answerIdsList],
        missionTriageQuestions: [...questionIdsList],
        missionTags: [],
        otherOrganizations: [],
      };
      for (let i = 0; i < this.compliantTag.length; i++) {
        data.missionTags.push({ tagId: Number(this.compliantTag[i]) });
      }
      for (let i = 0; i < this.compliantOtherOrganizations.length; i++) {
        data.otherOrganizations.push(Number(this.compliantOtherOrganizations[i]));
      }
      for (let i = 0; i < this.listOfSelectedCodes.length; i++) {
        data.mission115Suggestions.push({
          count: Number(this.listOfSelectedCodes[i].count),
          vehicleTypeId: Number(this.listOfSelectedCodes[i].id),
        });
      }
      if (data.missionTags.length == 0) {
        data.missionTags = null;
      }
      if (data.mission115Suggestions.length == 0) {
        data.mission115Suggestions = null;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('finalizeMission', data).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.type == "call") {
            this.$root.$refs.Home.closeForm(this.uniqueId);
          } else if (this.type == "hand") {
            if (this.$route.name == "mission115") {
              this.$root.$refs.Mission115View.getData();
            }
            this.$root.$refs.Home.closeForm(this.uniqueId);
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.finalizeMissionFuncion();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.finalizeMissionFuncion();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
        this.cleanForm();
      });
    },
    //deployment
    activeNewDeploymentMissionFunction: function () {
      if (!this.deploymentInformTypeId) {
        this.snackText = 'نوع درخواست نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.deploymentRank == null || this.deploymentRank == undefined) {
        this.snackText = 'اولویت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      /*if (!this.deploymentRecoveryPhone) {
                this.snackText = "تلفن پیگیری نمی تواند خالی باشد";
                this.$refs.snackRef.snackModel = true;
                this.snackColor = "#FF5252";
                this.snakIcon = "mdi-information";
                return;
            }*/
      if (!this.deploymentSelectedCity) {
        this.snackText = 'َشهر نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.deploymentSelectedCity) {
        if (!this.deploymentSelectedCity.id) {
          this.snackText = 'شهر نمی تواند خالی باشد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      } else {
        this.snackText = 'شهر نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.deploymentAddress) {
        this.snackText = 'آدرس نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      /* if (this.listOfDeploymentSelectedCodes.length == 0) {
                 this.snackText = "حداقل باید یک کد پیشنهادی انتخاب شود";
                 this.$refs.snackRef.snackModel = true;
                 this.snackColor = "#FF5252";
                 this.snakIcon = "mdi-information";
                 return;
             }*/
      let latitude = null;
      let longitude = null;
      if (this.position) {
        latitude = this.position.lat;
        longitude = this.position.lng;
      }
      let tempDuration = this.showPassedTime;
      let duration = tempDuration.split(':');
      let calculatedDuration = Number(duration[0] * 60) + Number(duration[1]);
      let data = {
        rank: Number(this.deploymentRank),
        otherPhoneNumber: this.deploymentRecoveryPhone,
        latitude: latitude,
        longitude: longitude,
        isLocationConfirmed: this.acceptLocationDeployment,
        informTypeId: Number(this.deploymentInformTypeId),
        address: this.deploymentAddress,
        cityId: this.deploymentSelectedCity ? this.deploymentSelectedCity.id : null,
        duration: calculatedDuration,
        mission115Suggestions: [],
        missionTags: [],
      };
      for (let i = 0; i < this.deploymentTag.length; i++) {
        data.missionTags.push({ tagId: Number(this.deploymentTag[i]) });
      }
      for (let i = 0; i < this.listOfDeploymentSelectedCodes.length; i++) {
        data.mission115Suggestions.push({
          count: Number(this.listOfDeploymentSelectedCodes[i].count),
          vehicleTypeId: Number(this.listOfDeploymentSelectedCodes[i].id),
        });
      }
      if (data.missionTags.length == 0) {
        data.missionTags = null;
      }
      if (data.mission115Suggestions.length == 0) {
        data.mission115Suggestions = null;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deploymentMission', data).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.cleanForm();
          if (this.$route.name != 'mission115') {
            this.$root.$refs.Home.closeDeploymentForm();
          } else {
            this.$root.$refs.Home.deploymentModal = false;
            this.getListOfCurrentMissionFunction();
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.activeNewDeploymentMissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.activeNewDeploymentMissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getMissionBy115Function: function (missionId, missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getMissionBy115', {
          missionId: missionId,
          missionPhoneId: missionPhoneId,
        })
        .then(() => {
          if (this.$store.state.missionModule.successFlag) {
            let temp = this.$store.state.missionModule.mission115;
            let tags = [];
            let otherOrgans = [];
            let gender = null;
            this.listOfEditMissionSelectedCodes = [];
            for (let i = 0; i < temp.missionTags.length; i++) {
              tags.push(temp.missionTags[i].tag.id);
            }
            for (let i = 0; i < temp.missionOtherOrganizationRequests.length; i++) {
              otherOrgans.push(temp.missionOtherOrganizationRequests[i].otherOrganization.id);
            }
            if (temp.missionCreationDetail) {
              if (
                temp.missionCreationDetail.gender != null &&
                temp.missionCreationDetail.gender != undefined
              ) {
                gender = temp.missionCreationDetail.gender;
              }
            }
            for (let i = 0; i < temp.mission115Suggestions.length; i++) {
              this.listOfEditMissionSelectedCodes.push({
                title: temp.mission115Suggestions[i].vehicleType.title,
                count: temp.mission115Suggestions[i].count,
                id: temp.mission115Suggestions[i].vehicleType.id,
              });
            }
            for (let i = 0; i < temp.missionLackOfCodes.length; i++) {
              this.missionLakeCodeList.push({
                title: temp.missionLackOfCodes[i].station
                  ? temp.missionLackOfCodes[i].station.title
                  : '-',
                code: temp.missionLackOfCodes[i].station
                  ? temp.missionLackOfCodes[i].station.code
                  : '-',
                id: temp.missionLackOfCodes[i].id,
              });
            }
            for (let i = 0; i < temp.callerIds.length; i++) {
              this.otherCallerIdList.push({
                number: temp.callerIds[i],
                id: i + 1,
              });
            }
            this.editMissionRank = temp.rank;
            this.editMissionRecoveryPhone = temp.otherPhoneNumber;
            this.editMissionChiefComplaint = temp.chiefComplaintText;
            this.editMissionDiagnosis = temp.diagnosis ? temp.diagnosis : null;
            this.editMissionTag = tags;
            this.editMissionOtherOrganizations = otherOrgans;
            this.editMissionChiefNote = temp.chiefComplaintNote ? temp.chiefComplaintNote : '';
            this.editMissionCity = temp.city ? temp.city.id : null;
            this.editMissionAddress = temp.address ? temp.address : '';
            this.editMissionNote = temp.note ? temp.note : '';
            this.editMissionNumberOfPatient = temp.numberOfPatients;
            this.editMissionPatientFirstName = temp.missionCreationDetail
              ? temp.missionCreationDetail.firstName
              : '';
            this.editMissionPatientLastName = temp.missionCreationDetail
              ? temp.missionCreationDetail.lastName
              : '';
            this.editMissionPatientGender = gender;
            this.editMissionPatientRelation = temp.missionCreationDetail
              ? temp.missionCreationDetail.relation
              : '';
            this.editMissionPatientAgeYear = temp.missionCreationDetail
              ? temp.missionCreationDetail.ageYear
              : '';
            this.editMissionPatientAgeMonth = temp.missionCreationDetail
              ? temp.missionCreationDetail.ageMonth
              : '';

            this.editMissionIsPatientNewBorn = temp?.missionCreationDetail?.isNewBorn;
            this.editMissionPatientAgeDay = temp?.missionCreationDetail?.ageDay;
            this.editMissionPatientNationalCode = temp.missionCreationDetail
              ? temp.missionCreationDetail.nationalCode
              : '';
            this.patientLat = temp.latitude ? temp.latitude : null;
            this.patientLng = temp.longitude ? temp.longitude : null;
            if (this.patientLat) {
              this.position.lat = this.patientLat;
              this.position.lng = this.patientLng;
            }
            //this.EditMissionPhoneId=
            if (this.load.val) {
              this.load.val = false;
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.missionModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getMissionBy115Function(missionId, missionPhoneId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getMissionBy115Function(missionId, missionPhoneId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    edit115MissionFunction: function (uniqueId_NewCall = "") {
      if (this.editMissionRank == null || this.editMissionRank == undefined) {
        this.snackText = 'اولویت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.editMissionChiefComplaint) {
        this.snackText = 'شکایت اصلی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.editMissionDiagnosis) {
        this.snackText = 'تشخیص احتمالی پرستار نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.editMissionCity) {
        this.snackText = 'شهر نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.editMissionAddress) {
        this.snackText = 'آدرس نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      let gender = null;
      if (this.editMissionPatientGender != null && this.editMissionPatientGender != undefined) {
        gender = Number(this.editMissionPatientGender);
      }
      let editMissionDiagnosisId = null;
      if (this.editMissionDiagnosis.id) {
        editMissionDiagnosisId = this.editMissionDiagnosis.id;
      } else {
        editMissionDiagnosisId = this.editMissionDiagnosis;
      }
      let data = {
        missionId: this.missionId,
        missionPhoneId: this.missionPhoneId,
        rank: Number(this.editMissionRank),
        otherPhoneNumber: this.editMissionRecoveryPhone,
        chiefComplaintNote: this.editMissionChiefNote,
        chiefComplaintText: this.editMissionChiefComplaint,
        diagnosisId: Number(editMissionDiagnosisId),
        address: this.editMissionAddress,
        cityId: this.editMissionCity ? this.editMissionCity : null,
        note: this.editMissionNote,
        numberOfPatients: Number(this.editMissionNumberOfPatient) || null,
        mission115Suggestions: [],
        missionCreationDetail: {
          firstName: this.editMissionPatientFirstName,
          lastName: this.editMissionPatientLastName,
          gender: gender,
          relation: this.editMissionPatientRelation,
          ageMonth: this.editMissionPatientAgeMonth
            ? Number(this.editMissionPatientAgeMonth)
            : null,
          ageDay: this.editMissionPatientAgeDay ? Number(this.editMissionPatientAgeDay) : null,
          isNewBorn: this.editMissionIsPatientNewBorn,
          nationalCode: this.editMissionPatientNationalCode
            ? this.editMissionPatientNationalCode
            : null,
          ageYear: this.editMissionPatientAgeYear ? Number(this.editMissionPatientAgeYear) : null,
          missionId: this.missionId,
        },
        missionTags: [],
        otherOrganizations: [],
      };
      for (let i = 0; i < this.listOfEditMissionSelectedCodes.length; i++) {
        data.mission115Suggestions.push({
          count: Number(this.listOfEditMissionSelectedCodes[i].count),
          vehicleTypeId: Number(this.listOfEditMissionSelectedCodes[i].id),
        });
      }
      if (data.mission115Suggestions.length == 0) {
        data.mission115Suggestions = null;
      }
      if (this.editMissionTag) {
        for (let i = 0; i < this.editMissionTag.length; i++) {
          data.missionTags.push({ tagId: Number(this.editMissionTag[i]) });
        }
        if (data.missionTags.length == 0) {
          data.missionTags = null;
        }
      } else {
        data.missionTags = null;
      }
      if (this.editMissionOtherOrganizations) {
        for (let i = 0; i < this.editMissionOtherOrganizations.length; i++) {
          data.otherOrganizations.push(Number(this.editMissionOtherOrganizations[i]));
        }
        if (data.otherOrganizations.length == 0) {
          data.otherOrganizations = null;
        }
      } else {
        data.otherOrganizations = null;
      }
      this.$store.dispatch('edit115Mission', data).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          this.cleanForm();
          this.changeToOldTitle();
          if (this.type == 'fromMainList') {
            this.$root.$refs.Mission115View.edit115MissionModal = false;
          } else if (this.type == 'fromNewCall') {
            this.$root.$refs[`newCallComponent_${uniqueId_NewCall}`].currentMissionModal = false;
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.edit115MissionFunction(uniqueId_NewCall ?? "");
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.edit115MissionFunction(uniqueId_NewCall ?? "");
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getMissionTimesFunction: function (missionId, missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getMissionTime', {
          missionId: missionId,
          missionPhoneId: missionPhoneId,
        })
        .then(() => {
          if (this.$store.state.missionModule.successFlag) {
            let temp = this.$store.state.missionModule.times;
            if (this.tab == 'two') {
              //نمایش زمان های ماموریت در 115
              this.readyTimeData(temp);
            }
            if (this.editTab == 'time') {
              //نمایش زمان های ماموریت در 800
              //this.readyTimeData(temp);
              this.getMissionPhoneFenceTimeFuntion(missionPhoneId, temp);
            }
            if (this.$route.name == 'dashboardFollowUp') {
              //نمایش زمان های ماموریت در داشبورد پیگیری
              //this.readyTimeData(temp);
              this.getMissionPhoneFenceTimeFuntion(missionPhoneId, temp);
            }
            if (this.$route.name == 'missionReport') {
              //گزارش پرونده
              this.getMissionPhoneFenceTimeFuntion(missionPhoneId, temp);
            }
            if (this.load.val) {
              this.load.val = false;
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.missionModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getMissionTimesFunction(missionId, missionPhoneId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getMissionTimesFunction(missionId, missionPhoneId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    //800 part
    getListOfMissionsForDispatchTopListFunction_OOLLDD: function (needSound = true, needRefresh = true) {
      if (!this.load.val && needRefresh) {
        this.load.val = true;
      }
      this.isTopListLoading = true;
      this.$store
        .dispatch('getDispatchTopList')
        .then(() => {
          if (this.$store.state.missionModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.currentMission800TopList = [];
            let temp = this.$store.state.missionModule.dispathMissionTopList;
            this.stopSound2();

            if (temp.length > 0 && needSound && !this.silentTopListSound) {
              this.topListSoundStop = false;
            }
            for (let i = 0; i < temp.length; i++) {
              let reciveTime = '';
              let user = '';
              let rank = '';
              let isStarred = false;
              let otherStarred = false;
              let iconColor = '';
              let afterStyle_new800 = '';
              let iconClass = '';
              let locationStateIcon = '';
              let locationState = 0;
              let address = '';
              let cc = '';
              let cc_only = '';
              let chiefComplaintNote_only = '-';
              let chiefComplaintText_only = '-';
              let customPhone = '';
              let missionIsStarred_Item = false;
              if (temp[i].diagnosis) {
                cc = temp[i].diagnosis.title;
                cc_only = temp[i].diagnosis.title;
              }
              if (temp[i].chiefComplaintNote) {
                cc += '( ' + temp[i].chiefComplaintNote + ' )';
                chiefComplaintNote_only = temp[i].chiefComplaintNote;
              }
              if (temp[i].chiefComplaintText) {
                chiefComplaintText_only = temp[i].chiefComplaintText;
              }

              if (temp[i].latitude && temp[i].longitude && temp[i].isLocationConfirmed) {
                locationStateIcon = 'mdi-map-marker-check mdi-18px';
                locationState = 1
              } else if (
                temp[i].latitude &&
                temp[i].longitude &&
                temp[i].isLocationConfirmed == false
              ) {
                locationStateIcon = 'mdi-map-marker mdi-18px';
                locationState = 2
              }
              if (temp[i].starredZone) {
                if (temp[i].selectedZone) {
                  if (temp[i].starredZone.id == temp[i].selectedZone.id) {
                    isStarred = true;
                  } else {
                    otherStarred = true;
                  }
                }
              }
              if (temp[i].creationDate) {
                reciveTime = Vue.moment(temp[i].creationDate).format('HH:mm:ss');
              }
              if (temp[i].creationUser) {
                let fName = temp[i].creationUser.firstName ? temp[i].creationUser.firstName : '';
                let lName = temp[i].creationUser.lastName ? temp[i].creationUser.lastName : '';
                const sipExtension = temp[i]?.creationUser?.sipExtension;
                user = `${fName} ${lName}${sipExtension ? `(${sipExtension})` : ''}`;
              }
              if (temp[i].rank == 0) {
                rank = 'سفید';
                iconColor = '#c7c7c7';
                iconClass = '';
                afterStyle_new800 = 'whiteStyle'
              } else if (temp[i].rank == 1) {
                rank = 'سبز';
                iconColor = '#3BCA79';
                iconClass = '';
                afterStyle_new800 = 'greenStyle'
              } else if (temp[i].rank == 2) {
                rank = 'زرد';
                iconColor = '#F2BD27';
                iconClass = 'rank-icon-anim2';
                afterStyle_new800 = 'yellowStyle'
              } else if (temp[i].rank == 3) {
                rank = 'قرمز';
                iconColor = '#F56060';
                iconClass = 'rank-icon-anim1';
                afterStyle_new800 = 'redStyle'
              }
              // for 10-19
              if (temp[i]?.lastState?.includes('10-19')) {
                // iconColor = '#F56060';
                iconClass = '10-19';
              }
              // end for 10-19
              if (temp[i].missionType == 1) {
                address = '#استقرار ' + temp[i].address;
              } else {
                address = temp[i].address;
              }
              if (temp[i].callerId) {
                customPhone = temp[i].callerId
                if (temp[i].otherPhoneNumber) {
                  customPhone += ' - ';
                }
              }
              if (temp[i].otherPhoneNumber) {
                customPhone += temp[i].otherPhoneNumber;
              }
              let currentUserInfo = this.$store.state.userModule.user;
              if (currentUserInfo.currentZoneId) {
                if (temp[i].starredZone) {
                  if (currentUserInfo.currentZoneId == temp[i].starredZone.id) {
                    missionIsStarred_Item = true;
                  } else {
                    missionIsStarred_Item = false;
                  }
                } else {
                  missionIsStarred_Item = false;
                }
              } else {
                missionIsStarred_Item = false;
              }

              this.currentMission800TopList.push({
                city: temp[i].city ? temp[i].city.title : '-',
                address: address,
                reciveTime: reciveTime,
                phone: temp[i].callerId ? temp[i].callerId : '-',
                code: temp[i].mission115Suggestion ? temp[i].mission115Suggestion : '-',
                zone: temp[i].selectedZone ? temp[i].selectedZone.title : '-',
                user: user,
                id: temp[i].id,
                isStarred: isStarred,
                otherStarred: otherStarred,
                rank: rank,
                iconColor: iconColor,
                iconClass: iconClass,
                locationStateIcon: locationStateIcon,
                cc: cc,
                cc_only: cc_only,
                chiefComplaintNote_only: chiefComplaintNote_only,
                chiefComplaintText_only: chiefComplaintText_only,
                afterStyle_new800: afterStyle_new800,
                locationState: locationState,
                customPhone: customPhone,
                customPhoneList: customPhone ? customPhone?.replace(/[-_,.\s]/g, " ")?.split(' ')?.filter(Boolean) : [],
                mission115Suggestions: temp[i].mission115Suggestions,
                missionIsStarred_Item: missionIsStarred_Item

              });
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }

            if (this.$store.state.missionModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfMissionsForDispatchTopListFunction(needSound, needRefresh);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfMissionsForDispatchTopListFunction(needSound, needRefresh);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.isTopListLoading = false));
    },


    getListOfMissionsForDispatchTopListFunction: function (needSound = true, needRefresh = true) {
      if (!this.load.val && needRefresh) {
        this.load.val = true;
      }
      this.isTopListLoading = true;
      return this.$store.dispatch('getDispatchTopList')
        .then(() => {
          if (this.$store.state.missionModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.currentMission800TopList = [];
            let temp = this.$store.state.missionModule.dispathMissionTopList;
            this.stopSound2();
            if (temp.length > 0 && needSound && !this.silentTopListSound) {
              this.topListSoundStop = false;
            }
            for (let i = 0; i < temp.length; i++) {
              let reciveTime = '';
              let user = '';
              let rank = '';
              let isStarred = false;
              let otherStarred = false;
              let iconColor = '';
              let afterStyle_new800 = '';
              let iconClass = '';
              let locationStateIcon = '';
              let locationState = 0;
              let address = '';
              let cc = '';
              let cc_only = '';
              let chiefComplaintNote_only = '-';
              let chiefComplaintText_only = '-';
              let customPhone = '';
              let missionIsStarred_Item = false;
              if (temp[i].diagnosis) {
                cc = temp[i].diagnosis.title;
                cc_only = temp[i].diagnosis.title;
              }
              if (temp[i].chiefComplaintNote) {
                cc += '( ' + temp[i].chiefComplaintNote + ' )';
                chiefComplaintNote_only = temp[i].chiefComplaintNote;
              }
              if (temp[i].chiefComplaintText) {
                chiefComplaintText_only = temp[i].chiefComplaintText;
              }

              if (temp[i].latitude && temp[i].longitude && temp[i].isLocationConfirmed) {
                locationStateIcon = 'mdi-map-marker-check mdi-18px';
                locationState = 1
              } else if (
                temp[i].latitude &&
                temp[i].longitude &&
                temp[i].isLocationConfirmed == false
              ) {
                locationStateIcon = 'mdi-map-marker mdi-18px';
                locationState = 2
              }
              if (temp[i].starredZone) {
                if (temp[i].selectedZone) {
                  if (temp[i].starredZone.id == temp[i].selectedZone.id) {
                    isStarred = true;
                  } else {
                    otherStarred = true;
                  }
                }
              }
              if (temp[i].creationDate) {
                reciveTime = Vue.moment(temp[i].creationDate).format('HH:mm:ss');
              }
              if (temp[i].creationUser) {
                let fName = temp[i].creationUser.firstName ? temp[i].creationUser.firstName : '';
                let lName = temp[i].creationUser.lastName ? temp[i].creationUser.lastName : '';
                const sipExtension = temp[i]?.creationUser?.sipExtension;
                user = `${fName} ${lName}${sipExtension ? `(${sipExtension})` : ''}`;
              }
              if (temp[i].rank == 0) {
                rank = 'سفید';
                iconColor = '#c7c7c7';
                iconClass = '';
                afterStyle_new800 = 'whiteStyle'
              } else if (temp[i].rank == 1) {
                rank = 'سبز';
                iconColor = '#3BCA79';
                iconClass = '';
                afterStyle_new800 = 'greenStyle'
              } else if (temp[i].rank == 2) {
                rank = 'زرد';
                iconColor = '#F2BD27';
                iconClass = 'rank-icon-anim2';
                afterStyle_new800 = 'yellowStyle'
              } else if (temp[i].rank == 3) {
                rank = 'قرمز';
                iconColor = '#F56060';
                iconClass = 'rank-icon-anim1';
                afterStyle_new800 = 'redStyle'
              }
              // for 10-19
              if (temp[i]?.lastState?.includes('10-19')) {
                // iconColor = '#F56060';
                iconClass = '10-19';
              }
              // end for 10-19
              if (temp[i].missionType == 1) {
                address = '#استقرار ' + temp[i].address;
              } else {
                address = temp[i].address;
              }
              if (temp[i].callerId) {
                customPhone = temp[i].callerId
                if (temp[i].otherPhoneNumber) {
                  customPhone += ' - ';
                }
              } else if (temp[i].otherPhoneNumber) {
                customPhone += temp[i].otherPhoneNumber;
              }
              let currentUserInfo = this.$store.state.userModule.user;
              if (currentUserInfo.currentZoneId) {
                if (temp[i].starredZone) {
                  if (currentUserInfo.currentZoneId == temp[i].starredZone.id) {
                    missionIsStarred_Item = true;
                  } else {
                    missionIsStarred_Item = false;
                  }
                } else {
                  missionIsStarred_Item = false;
                }
              } else {
                missionIsStarred_Item = false;
              }

              this.currentMission800TopList.push({
                city: temp[i].city ? temp[i].city.title : '-',
                address: address,
                reciveTime: reciveTime,
                phone: temp[i].callerId ? temp[i].callerId : '-',
                code: temp[i].mission115Suggestion ? temp[i].mission115Suggestion : '-',
                zone: temp[i].selectedZone ? temp[i].selectedZone.title : '-',
                user: user,
                id: temp[i].id,
                isStarred: isStarred,
                otherStarred: otherStarred,
                rank: rank,
                iconColor: iconColor,
                iconClass: iconClass,
                locationStateIcon: locationStateIcon,
                cc: cc,
                cc_only: cc_only,
                chiefComplaintNote_only: chiefComplaintNote_only,
                chiefComplaintText_only: chiefComplaintText_only,
                afterStyle_new800: afterStyle_new800,
                locationState: locationState,
                customPhone: customPhone,
                customPhoneList: customPhone ? customPhone?.replace(/[-_,.\s]/g, " ")?.split(' ')?.filter(Boolean) : [],
                mission115Suggestions: temp[i].mission115Suggestions,
                missionIsStarred_Item: missionIsStarred_Item

              });
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }

            if (this.$store.state.missionModule.errorStatus) {
              return this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  return this.getListOfMissionsForDispatchTopListFunction(needSound, needRefresh);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionModule.error400) {
              return this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  return this.getListOfMissionsForDispatchTopListFunction(needSound, needRefresh);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.isTopListLoading = false));
    },


    getMissionForDispatchSendMissionFunction: function (id) {
      this.missionSendInfoNew = null
      this.load.val = true;

      this.$store
        .dispatch('getDispatchCodeBy800User', id)
        .then(() => {
          if (this.$store.state.missionModule.successFlag) {
            this.stopTopListSound();
            this.missionSendInfo = this.$store.state.missionModule.dispatchCode;

            //NEW 800
            const mytemp = this.$store.state.missionModule.dispatchCode;

            try {



              let reciveTime = '--';
              let codeSugg = '--';
              let otherOrgan = '--';
              let rank = '';
              let isStarred = false;
              let otherStarred = false;
              let iconColor = '';
              let afterStyle_new800 = '';
              let iconClass = '';
              let locationStateIcon = '';
              let locationState = 0;
              let address = '--';
              let cc = '--';
              let cc_only = '--';
              let user = '';
              let chiefComplaintNote_only = '--';
              let chiefComplaintText_only = '--';
              let customPhone = '';
              let patiantPhoneNumbers = [];
              let phone = '-';

              if (mytemp.diagnosis) {
                cc = mytemp.diagnosis.title;
                cc_only = mytemp.diagnosis.title;
              }
              if (mytemp.chiefComplaintNote) {
                cc += '( ' + mytemp.chiefComplaintNote + ' )';
                chiefComplaintNote_only = mytemp.chiefComplaintNote;
              }
              if (mytemp.chiefComplaintText) {
                chiefComplaintText_only = mytemp.chiefComplaintText;
              }

              if (mytemp.creationDate) {
                reciveTime = Vue.moment(mytemp.creationDate).format('HH:mm:ss');
              }

              if (mytemp.latitude && mytemp.longitude && mytemp.isLocationConfirmed) {
                locationStateIcon = 'mdi-map-marker-check mdi-18px';
                locationState = 1
              } else if (
                mytemp.latitude &&
                mytemp.longitude &&
                mytemp.isLocationConfirmed == false
              ) {
                locationStateIcon = 'mdi-map-marker mdi-18px';
                locationState = 2
              }
              if (mytemp.starredZone) {
                if (mytemp.selectedZone) {
                  if (mytemp.starredZone.id == mytemp.selectedZone.id) {
                    isStarred = true;
                  } else {
                    otherStarred = true;
                  }
                }
              }

              if (mytemp.creationUser) {
                let fName = mytemp.creationUser.firstName ? mytemp.creationUser.firstName : '';
                let lName = mytemp.creationUser.lastName ? mytemp.creationUser.lastName : '';
                const sipExtension = mytemp?.creationUser?.sipExtension;
                user = `${fName} ${lName}${sipExtension ? `(${sipExtension})` : ''}`;
              }

              if (mytemp.rank == 0) {
                rank = 'سفید';
                iconColor = '#c7c7c7';
                iconClass = '';
                afterStyle_new800 = 'whiteStyle'
              } else if (mytemp.rank == 1) {
                rank = 'سبز';
                iconColor = '#3BCA79';
                iconClass = '';
                afterStyle_new800 = 'greenStyle'
              } else if (mytemp.rank == 2) {
                rank = 'زرد';
                iconColor = '#F2BD27';
                iconClass = 'rank-icon-anim2';
                afterStyle_new800 = 'yellowStyle'
              } else if (mytemp.rank == 3) {
                rank = 'قرمز';
                iconColor = '#F56060';
                iconClass = 'rank-icon-anim1';
                afterStyle_new800 = 'redStyle'
              }
              // for 10-19
              if (mytemp?.lastState?.includes('10-19')) {
                // iconColor = '#F56060';
                iconClass = '10-19';
              }
              // end for 10-19
              if (mytemp.missionType == 1) {
                address = '#استقرار ' + mytemp.address;
              } else {
                address = mytemp.address;
              }
              if (mytemp.callerId) {
                customPhone = mytemp.callerId
                if (mytemp.otherPhoneNumber) {
                  customPhone += ' - ';
                }
              }
              if (mytemp.otherPhoneNumber) {
                customPhone += mytemp.otherPhoneNumber;
              }

              if (mytemp.mission115Suggestions && mytemp.mission115Suggestions.length > 0) {
                codeSugg = mytemp.mission115Suggestions
                  .map(item => `${item.vehicleType.title} (${item.count})`)
                  .join(', ');
              }

              if (mytemp.missionOtherOrganizationRequests && mytemp.missionOtherOrganizationRequests.length > 0) {
                otherOrgan = mytemp.missionOtherOrganizationRequests
                  .map(item => `${item.otherOrganization.title}`)
                  .join(', ');
              }

              if (mytemp.callerId) {
                phone = mytemp.callerId;
                patiantPhoneNumbers.push(phone);
                if (mytemp.otherPhoneNumber) {
                  phone += ' - ' + mytemp.otherPhoneNumber;
                  let tmpPhone = mytemp.otherPhoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
                  for (let j = 0; j < tmpPhone.length; j++) {
                    patiantPhoneNumbers.push(tmpPhone[j]);
                  }
                }
              } else if (mytemp.otherPhoneNumber) {
                phone = mytemp.otherPhoneNumber;
                let tmpPhone = mytemp.otherPhoneNumber?.replace(/[-_,.\s]/g, " ").split(' ');
                for (let j = 0; j < tmpPhone.length; j++) {
                  if (tmpPhone[j]) {
                    patiantPhoneNumbers.push(tmpPhone[j]);
                  }
                }
              }



              this.missionSendInfoNew = {
                city: mytemp.city ? mytemp.city.title : '-',
                address: address,
                reciveTime: reciveTime,
                phone: mytemp.callerId ? mytemp.callerId : '-',
                code: codeSugg,
                otherOrgan: otherOrgan,
                mission115Suggestions: mytemp?.mission115Suggestions ?? [],
                zone: mytemp.selectedZone ? mytemp.selectedZone.title : '-',
                user: user || '-',
                id: mytemp.id,
                isStarred: isStarred,
                otherStarred: otherStarred,
                rank: rank,
                iconColor: iconColor,
                iconClass: iconClass,
                locationStateIcon: locationStateIcon,
                cc: cc,
                cc_only: cc_only,
                chiefComplaintNote_only: chiefComplaintNote_only,
                chiefComplaintText_only: chiefComplaintText_only,
                afterStyle_new800: afterStyle_new800,
                locationState: locationState,
                customPhone: customPhone,
                customPhoneList: customPhone ? customPhone?.replace(/[-_,.\s]/g, " ")?.split(' ')?.filter(Boolean) : [],
                patiantPhoneNumbers: patiantPhoneNumbers
              };
            } catch (error) {
              console.log("A error : ", error);
            }

            // New 800



            if (this.missionSendInfo.rank == 0) {
              this.missionRankText = '4-سفید';
              this.missionRankIconClass = 'mx-2';
              this.missionRankIconColor = '';
            } else if (this.missionSendInfo.rank == 1) {
              this.missionRankText = '3-سبز';
              this.missionRankIconClass = 'mx-2';
              this.missionRankIconColor = '#3BCA79';
            } else if (this.missionSendInfo.rank == 2) {
              this.missionRankText = '2-زرد';
              this.missionRankIconClass = 'rank-icon-anim2 mx-2';
              this.missionRankIconColor = '#F2BD27';
            } else if (this.missionSendInfo.rank == 3) {
              this.missionRankText = '1-قرمز';
              this.missionRankIconClass = 'rank-icon-anim1 mx-2';
              this.missionRankIconColor = '#F56060';
            }

            let currentUserInfo = this.$store.state.userModule.user;
            if (currentUserInfo.currentZoneId) {
              if (this.missionSendInfo.starredZone) {
                if (currentUserInfo.currentZoneId == this.missionSendInfo.starredZone.id) {
                  this.missionIsStarred = true;
                } else {
                  this.missionIsStarred = false;
                }
              } else {
                this.missionIsStarred = false;
              }
            } else {
              this.missionIsStarred = false;
            }
            if (this.missionSendInfo.latitude) {
              this.patiantPosition = {
                lat: this.missionSendInfo.latitude,
                lng: this.missionSendInfo.longitude,
              };
              this.getListOfTopNearestPhonesFor800Function(
                this.missionSendInfo.latitude,
                this.missionSendInfo.longitude,
              );
            }
            this.getListOfReadyPhonesFor800Function();
            this.getListOfStationsForOther();
            this.mapInvalidate();
          } else {
            this.missionSendInfoNew = {}
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.missionModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getMissionForDispatchSendMissionFunction(id);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getMissionForDispatchSendMissionFunction(id);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.load.val = false));
    },
    removeSelectedZone800Function: function () {
      if (!this.load.val) {
        this.load.val = true;
      }

      this.$store.dispatch('removeSelectedZone800', this.missionId).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          // this.missionSuccesfulyRemove();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.removeSelectedZone800Function();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.removeSelectedZone800Function();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },

    removeMissionBy800UserFunction: function () {
      if (!this.removeReason) {
        this.snackText = 'لطفا توضیحات را وراد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        missionId: Number(this.missionId),
        note: this.removeReason,
      };
      this.$store.dispatch('removeMissionBy800', data).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = 'ماموریت با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.missionSuccesfulyRemove();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.removeMissionBy800UserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.removeMissionBy800UserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    starredMissionBy800UserFunction: function () {
      this.removeSelectedZone800Function()
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('missionStarredBy800', Number(this.missionId)).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = 'ماموریت با موفقیت ستاره دار شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.missionSuccessfulyStared();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.starredMissionBy800UserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.starredMissionBy800UserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    removeStarredMissionBy800UserFunction: function (id) {
      this.removeSelectedZone800Function()
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('removeMissionStarredBy800', Number(id)).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = 'عملیات با مموفقیت انجام شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.missionSuccessfulyStared();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.removeStarredMissionBy800UserFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.removeStarredMissionBy800UserFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    attachMissionBy800UserFunction: function () {
      if (!this.destinationMissionId) {
        this.snackText = 'لطفا ماموریت پیوست را انتخاب نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        sourceMissionId: Number(this.missionId),
        destinationMissionId: Number(this.destinationMissionId),
      };
      this.$store.dispatch('attachMissionBy800User', data).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = 'ماموریت با موفقیت پیوست شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.missionSuccessfulyAttach();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.attachMissionBy800UserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.attachMissionBy800UserFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfRecentCallsFor115Report: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getRecentCalls115').then(() => {
        if (this.$store.state.missionModule.successFlag) {
          let temp = this.$store.state.missionModule.listOfRecentCalls115;
          this.callReport115List = [];
          for (let i = 0; i < temp.length; i++) {
            let date = '';
            let phone = '';
            let fullName = '-';
            let age = '-';
            let user = '';
            let patiantPhoneNumbers = [];
            if (temp[i].creationDate) {
              date = Vue.moment(temp[i].creationDate).format('jYYYY/jM/jD HH:mm:ss');
            }
            if (temp[i].callerId) {
              phone = temp[i].callerId;
              if (temp[i].otherPhoneNumber) {
                phone += ',' + temp[i].otherPhoneNumber;
              }
            } else if (temp[i].otherPhoneNumber) {
              phone = temp[i].otherPhoneNumber;
            }



            if (temp[i].callerId) {
              phone = temp[i].callerId;
              if (temp[i].otherPhoneNumber) {
                let tmpPhone1 = temp[i].otherPhoneNumber?.replace(/[-_,.\s]/g, "-");
                phone += '-' + tmpPhone1;
              }
            } else if (temp[i].otherPhoneNumber) {
              let tmpPhone1 = temp[i].otherPhoneNumber?.replace(/[-_,.\s]/g, "-");
              phone = tmpPhone1;
            }

            let phoneString = phone?.replace(/[-_,.\s]/g, " ").split(' ');
            for (let j = 0; j < phoneString.length; j++) {
              patiantPhoneNumbers.push(phoneString[j]);
            }

            if (temp[i].missionCreationDetail) {
              let fName = temp[i].missionCreationDetail.firstName;
              let lName = temp[i].missionCreationDetail.lastName;
              fullName = fName + ' ' + lName;
              if (temp[i].missionCreationDetail.ageYear) {
                age = `${temp[i].missionCreationDetail.ageYear} سال`;
                if (temp[i].missionCreationDetail.ageMonth) {
                  age += `و ${temp[i].missionCreationDetail?.ageMonth} ماه`;
                }
                if (temp[i].missionCreationDetail?.ageDay)
                  age += `و ${temp[i].missionCreationDetail.ageDay} روز`;
              } else if (temp[i].missionCreationDetail?.ageMonth) {
                age = `${temp[i].missionCreationDetail?.ageMonth} ماه `;
                age += `${temp[i].missionCreationDetail.ageDay} روز`;
              } else if (temp[i].missionCreationDetail?.ageDay) {
                age = temp[i].missionCreationDetail.ageDay + 'روز';
              }
            }
            if (temp[i].creationUser) {
              let fName = temp[i].creationUser.firstName;
              let lName = temp[i].creationUser.lastName;
              user = fName + ' ' + lName;
            }
            this.callReport115List.push({
              id: temp[i].id,
              myMissionId: temp[i].missionCreationDetail?.missionId,
              date: date,
              phone: phone,
              cheifComplaint:
                temp[i].diagnosis && temp[i].diagnosis.title ? temp[i].diagnosis.title : '-',
              note: temp[i].chiefComplaintNote ? temp[i].chiefComplaintNote : '-',
              result:
                temp[i].callTag && temp[i].callTag.persianTitle
                  ? temp[i].callTag.persianTitle
                  : '-',
              time: temp[i].missionCreationDuration ? temp[i].missionCreationDuration : '-',
              address: temp[i].address ? temp[i].address : '-',
              fullName: fullName,
              age: age,
              user: user,
              patiantPhoneNumbers: patiantPhoneNumbers
            });
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfRecentCallsFor115Report();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfRecentCallsFor115Report();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //admission
    addToMissionTagByAdmissionFunction: function (missionId, tagId) {
      if (this.$route.name == 'dashboardFollowUp') {
        if (!this.load.val) {
          this.load.val = true;
        }
      }
      let data = {
        missionId: missionId,
        tagId: tagId,
      };
      this.$store.dispatch('addToMissionTag', data).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          if (this.$route.name == 'dashboardFollowUp') {
            let tag = this.$store.state.missionModule.missionAddedTag;
            this.missionAddedTag(tag);
            if (this.load.val) {
              this.load.val = false;
            }
            return;
          }
          this.selectedtag = null;
          let temp = this.$store.state.missionModule.missionAddedTag;
          this.selectedTagsList.push({ tag: temp.tag, id: temp.id });
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addToMissionTagByAdmissionFunction(missionId, tagId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addToMissionTagByAdmissionFunction(missionId, tagId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    removeTagFromMissionByAdmissionFunction: function (id) {
      if (this.$route.name == 'dashboardFollowUp') {
        if (!this.load.val) {
          this.load.val = true;
        }
      }
      this.$store.dispatch('removeTagFromMission', id).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          if (this.$route.name == 'dashboardFollowUp') {
            this.missionRemoveTag(id);
            if (this.load.val) {
              this.load.val = false;
            }
            return;
          }
          for (let i = 0; i < this.selectedTagsList.length; i++) {
            if (this.selectedTagsList[i].id == id) {
              this.selectedTagsList.splice(i, 1);
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.removeTagFromMissionByAdmissionFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.removeTagFromMissionByAdmissionFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },


    downloadAttachment_NewFunction: function (path) {
      if (this.$route.name == 'dashboardFollowUp') {
        if (!this.load.val) {
          this.load.val = true;
        }
      }
      this.$store.dispatch('downloadAttachment_New', path).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          this.showError();
        }
      });
    },


    getMissionReportfunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      if (this.searchToDate == '') {
        this.searchToDate = null;
      }
      if (this.searchFromDate == '') {
        this.searchFromDate = null;
      }
      this.$store
        .dispatch('getMissionReport', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          missionIdentifier: this.searchMissionIdentifier,
          fullName: this.searchFullName,
          mainPhoneNumber: this.searchMainPhoneNumber,
          otherPhoneNumber: this.searchOtherPhoneNumber,
          phoneCode: this.searchPhoneCode,
          tagId: this.searchTagId,
          rank: this.searchRank,
          address: this.searchAddress,
          fromDate: this.searchFromDate,
          toDate: this.searchToDate,
          missionId: this.$route.query?.missionId,
          isUnknown: this.isSearchedUnknownPerson,
          currentUserReport: this.currentUserReport,
          patientResult: this.searchPatientResult,
          diagnosisId: this.chiefComplaintChangeText,
          searchCityId: this.searchCityId,
          // startTriage
        })
        .then(() => {
          if (this.$store.state.missionModule.successFlag) {
            let temp = this.$store.state.missionModule.missionReportInfo;
            this.makeReportDataReady(temp);
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.missionModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.missionModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.missionModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.missionModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getMissionReportfunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getMissionReportfunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },

    // دریافت اطلاعات مدد جو
    getPatientForEditReportFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPatientForEditReport', id).then(() => {
        if (this.$store.state.patientModule.successFlag) {
          let temp = this.$store.state.patientModule.patientSimpleDataReport;


          if (temp.ageTotalDays != null) {
            this.isChildren = true
          } else {
            this.isChildren = false
          }

          this.userDetail = new UserDetail(
            temp.id,                        // id
            temp.firstName,                 // firstName
            temp.lastName,                  // lastName
            temp.yearOfAge,                 // yearOfAge
            temp.gender,                    // gender
            temp.nationality,               // nationality
            '',                             // note
            temp.isUnknown,                 // isUnknown
            temp.monthOfAge,                // monthOfAge
            temp.ageTotalDays,              // ageTotalDays
            temp.nationalCode,              // nationalCode
            temp.clothesColorAndType,       // clothesColorAndType
            temp.specialCharacteristic,     // specialCharacteristic
            temp.birthDate,                 // birthDate
            temp.patientResult ?? null,
            temp.hospital?.id ?? null
          );

          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getPatientForEditReportFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.patientModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getPatientForEditReportFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    // ویرایش اطلاعات مدد جو
    setPatientForEditReportFunction: function () {
      const fd = new FormData();
      if (this.imgAttach) {
        fd.append('File', this.imgAttach, this.imgAttach.name);
      }

      fd.append('Id', this.userDetail.id || 0);
      fd.append('FirstName', this.userDetail.isUnknown ? '' : (this.userDetail.firstName || ''));
      fd.append('LastName', this.userDetail.isUnknown ? '' : (this.userDetail.lastName || ''));
      fd.append('IsUnknown', this.userDetail.isUnknown || false);

      fd.append('YearOfAge', this.userDetail.yearOfAge || '');
      fd.append('MonthOfAge', this.userDetail.monthOfAge || '');
      fd.append('AgeTotalDays', this.userDetail.ageTotalDays || '');
      fd.append('Nationality', this.userDetail.isUnknown ? '' : (this.userDetail.nationality || ''));
      fd.append('Gender', this.userDetail.isUnknown ? '' : (this.userDetail.gender || ''));
      fd.append('HospitalId', this.userDetail.hospitalId || '');

      fd.append('NationalCode', this.userDetail.isUnknown ? '' : (this.userDetail.nationalCode || ''));
      fd.append('ClothesColorAndType', this.userDetail.clothesColorAndType || '');
      fd.append('SpecialCharacteristic', this.userDetail.specialCharacteristic || '');
      fd.append('BirthDate', this.userDetail.isUnknown ? '' : (this.userDetail.birthDate || ''));
      fd.append('Note', this.userDetail.note || '');

      if (!this.load.val) {
        this.load.val = true;
      }

      this.$store.dispatch('setPatientForEditReport', fd).then(() => {
        if (this.$store.state.patientModule.successFlag) {
          this.imgAttach = null
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showEditUserDetaiModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getMissionReportfunction();
          this.snackText = ' اطلاعات مدد جو با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.userDetail = new UserDetail(null, '', '', null, '', '', '', false, null, null, null, '', '', '', null, null);
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setPatientForEditReportFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.patientModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setPatientForEditReportFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    // دریافت لیست ویرایش مددجو
    getModificationsPatientsFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getModificationsPatients', id).then(() => {
        if (this.$store.state.patientModule.successFlag) {
          this.listEditPationts = this.$store.state.patientModule.listModificationsPatients;

          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getModificationsPatientsFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.patientModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getModificationsPatientsFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    // افزودن فایل به ویرایش مددجو
    setModificationAttachmentPatientFunction: function (file, id, mypatientId) {

      if (!file) {
        this.imgAttach_inList = null;
        return;
      }

      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        this.$toast?.error('مجاز هستند PDF، JPG، JPEG و PNG فقط فرمت‌های');
        this.imgAttach_inList = null;
        return;
      }

      const maxSize = 3 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$toast?.error('حجم فایل نباید بیشتر از ۳ مگابایت باشد');
        this.imgAttach_inList = null;
        return;
      }

      const fd = new FormData();
      if (!this.imgAttach_inList) {
        this.snackText = 'فایل ارسالی را بررسی کنید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
      }

      fd.append('File', this.imgAttach_inList, this.imgAttach_inList.name);
      fd.append('PatientModificationId', id || 0);

      if (!this.load.val) {
        this.load.val = true;
      }

      this.$store.dispatch('modificationAttachmentPatient', fd).then(() => {
        if (this.$store.state.patientModule.successFlag) {
          this.imgAttach_inList = null
          // this.$refs.confirm.showConfirmDialog = false;
          // this.disabelConfirm = false;
          // this.showEditUserDetaiModal = false;
          this.getModificationsPatientsFunction(mypatientId)
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = 'فایل پیوست با موفقیت ثبت شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setModificationAttachmentPatientFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.patientModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setModificationAttachmentPatientFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    downloadAttachEditPatientFunction: function (id, fileExtension) {
      if (!this.load.val) {
        this.load.val = true;
      }

      this.$store.dispatch('downloadModificationAttachment', id).then(() => {
        if (this.$store.state.patientModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientModule.file) {
            // console.log("AAA : ", this.$store.state.patientModule.file);
            const url = window.URL.createObjectURL(new Blob([this.$store.state.patientModule.file]));
            const link = document.createElement('a');
            link.href = url;
            var today = new Date();
            var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            const fileName = `پیوست-${date}`;
            link.setAttribute('download', fileName + fileExtension);
            document.body.appendChild(link);
            link.click();
          } else {
            this.snackText = 'فایل جهت دانلود وجود ندارد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.downloadAudioFunction(id, fileExtension);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.patientModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.downloadAudioFunction(id, fileExtension);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },

    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    getMissionCallsfunction: function (missionId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMissionCalls', missionId).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          let temp = this.$store.state.missionModule.missionCalls;
          this.makeMissionCallsDataReady(temp);
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionCallsfunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionCallsfunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getMissionTriagesfunction: function (missionId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMissionTriages', missionId).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          let temp = this.$store.state.missionModule.missionTriages;
          this.makeMissionTriagesDataReady(temp);
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionTriagesfunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionTriagesfunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getMissionConfirmationFunction: function (missionId) {
      const params = {
        missionId,
      };
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMissionConfirmationDispatch', params).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          const temp = this.$store.state.missionModule.missionConfirmations;
          this.missionConfirmations = this.tranformMissionConfirmation(temp);
        } else {
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMissionConfirmationFunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMissionConfirmationFunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getMissionLogsfunction: function (missionId, missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getMissionLogs', {
          missionId: missionId,
          missionPhoneId: missionPhoneId,
        })
        .then(() => {
          if (this.$store.state.missionModule.successFlag) {
            let temp = this.$store.state.missionModule.missionLogs;
            this.makeMissionLogsDataReady(temp);
            if (this.load.val) {
              this.load.val = false;
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.missionModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getMissionLogsfunction(missionId, missionPhoneId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getMissionLogsfunction(missionId, missionPhoneId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getMission115Detailfunction: function (missionId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getMission115Detail', missionId).then(() => {
        if (this.$store.state.missionModule.successFlag) {
          let temp = this.$store.state.missionModule.mission115Detail;
          this.ready115Info(temp);
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getMission115Detailfunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getMission115Detailfunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    sendPationtNewLocationFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        missionId: this.missionId,
        latitude: this.patiantPosition.lat,
        longitude: this.patiantPosition.lng,
      };
      this.$store
        .dispatch('sendPationtNewLocation', data)
        .then(() => {
          if (this.$store.state.missionModule.successFlag) {
            this.hasNewLocation = false;
            this.showSuccessAlert('موقعیت بیمار با موفقیت تغییر یافت');
            this.getMissionConfirmationFunction(this.missionId);
          } else {
            if (this.$store.state.missionModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.sendPationtNewLocationFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.missionModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.sendPationtNewLocationFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    showError: function () {
      this.snackText = this.$store.state.missionModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
